export default "__VITE_ASSET__Dd7r6SE6__"